import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

export const listBadges = (data) => {
  return HttpService.post(
    ApiService.icdc.module.reportrnb.badge + '?page=1&take=10',
    {
      ...data
    }
  );
};

export const listMissions = (data) => {
  return HttpService.post(
    ApiService.icdc.module.reportrnb.mission + '?page=1&take=10',
    {
      ...data
    }
  );
};

export const listLadderboard = (data) => {
  return HttpService.post(
    ApiService.icdc.module.reportrnb.point + '?page=1&take=10',
    {
      ...data
    }
  );
};

export const detailUser = (data) => {
  return HttpService.post(
    ApiService.icdc.module.reportrnb.overviewUser + '?page=1&take=10',
    {
      ...data
    }
  );
};

export const getTopMission = () => {
  return HttpService.get(
    `${ApiService.icdc.module.reportrnb.topMission}?page=1&take=5`
  );
};

export const getTopVoucher = () => {
  return HttpService.get(
    `${ApiService.icdc.module.reportrnb.topVoucher}?page=1&take=5`
  );
};

export const getChartPerbandinganPoint = () => {
  return HttpService.get(
    `${ApiService.icdc.module.reportrnb.chartPerbandinganPoint}?page=1&take=5`
  );
};

export const getChartPerbandinganLevel = () => {
  return HttpService.get(
    `${ApiService.icdc.module.reportrnb.chartPerbandinganLevel}?page=1&take=5`
  );
};

export const getChartRiwayatCompletionMission = () => {
  return HttpService.get(
    `${ApiService.icdc.module.reportrnb.chartRiwayatCompletionMission}?page=1&take=5`
  );
};

export const getChartRiwayatRedeem = () => {
  return HttpService.get(
    `${ApiService.icdc.module.reportrnb.chartRiwayatRedeem}?page=1&take=5`
  );
};
